let base = process.env.NODE_ENV === "development" ? "https://findw.co.kr" : window.location.origin;
// "https://noorim.org"
export default {
    url: base + '/api',
    timeout: 6 * 1000 * 10 * 10 * 2, // 20분
};